<ws-modal-wrapper
    headerLabel="Appeal Savings Calculation Details"
    [hideSave]="true"
    [hideCancel]="true"
    [hideFooter]="true"
    acceptLabel=""
    (cancel)="close()"
    [loading]="!initialized"
    [useAceStyles]="true"
>
    <div
        style="max-height: 40em; overflow-y: auto"
        class="appeal-savings-calculations-details-modal table-responsive ws-flex-align-items-center ws-stretch"
    >
        @if (initialized) {
            <table style="width: 100%" class="table table-striped table-bordered table-hover text-end">
                <thead>
                    <tr>
                        @if (showParcelInfo) {
                            <th></th>
                        }
                        <th></th>
                        <th></th>
                        @if (showMarketValue) {
                            <th>Market Value</th>
                        }
                        @if (showCap) {
                            <th>{{ capHeader }}</th>
                        }
                        @if (showExemption) {
                            <th>Exemption</th>
                        }
                        <th>Taxable Market Value</th>
                        @if (showTaxableAssessedValue) {
                            <th>Taxable Assessed Value</th>
                        }
                        @if (showBaseRate) {
                            <th>Base Rate</th>
                        }
                        @if (showRate) {
                            <th>Rate</th>
                        }
                        <th>Taxes</th>
                    </tr>
                </thead>
                <tbody>
                    @for (parcelCalculation of parcelSavingsCalculations; track parcelCalculation) {
                        @for (
                            revisionAppeal of parcelCalculation.appealRevisionCalculations;
                            track revisionAppeal;
                            let i = $index
                        ) {
                            <tr>
                                @if (i == 0) {
                                    @if (showParcelInfo) {
                                        <td>Parcel {{ parcelCalculation.parcelName }}</td>
                                    }
                                    <td>{{ parcelCalculation.appealedRevisionDescription }}</td>
                                }
                                @if (i != 0) {
                                    @if (showParcelInfo) {
                                        <td></td>
                                    }
                                    <td></td>
                                }
                                <td>{{ revisionAppeal.taxableValueName }}</td>
                                @if (showMarketValue) {
                                    <td>{{ revisionAppeal.marketValue ?? 0 | number }}</td>
                                }
                                @if (showCap) {
                                    <td>{{ revisionAppeal.cap | number }}</td>
                                }
                                @if (showExemption) {
                                    <td>{{ revisionAppeal.exemption | number }}</td>
                                }
                                <td>{{ revisionAppeal.taxableMarketValue | number }}</td>
                                @if (showTaxableAssessedValue) {
                                    <td>{{ revisionAppeal.taxableAssessedValue ?? 0 | number: '1.0-0' }}</td>
                                }
                                @if (showBaseRate) {
                                    <td>{{ revisionAppeal.baseRate | percent: '1.6-6' }}</td>
                                }
                                @if (showRate) {
                                    <td>{{ revisionAppeal.rate | percent: '1.6-6' }}</td>
                                }
                                <td>{{ revisionAppeal.taxAmount | currency: 'USD' }}</td>
                            </tr>
                        }
                        <tr>
                            <td [attr.colspan]="rightJustifyCellValue">{{
                                parcelCalculation.appealRevisionTotalTaxAmount | currency: 'USD'
                            }}</td>
                        </tr>
                        <tr>
                            <td [attr.colspan]="rightJustifyCellValue"></td>
                        </tr>
                        @for (
                            outcomeRevision of parcelCalculation.outcomeRevisionCalculations;
                            track outcomeRevision;
                            let i = $index
                        ) {
                            <tr>
                                @if (showParcelInfo) {
                                    <td></td>
                                }
                                @if (i == 0) {
                                    <td>{{ parcelCalculation.outcomeRevisionDescription }}</td>
                                }
                                @if (i != 0) {
                                    <td></td>
                                }
                                <td>{{ outcomeRevision.taxableValueName }}</td>
                                @if (showMarketValue) {
                                    <td>{{ outcomeRevision.marketValue ?? 0 | number }}</td>
                                }
                                @if (showCap) {
                                    <td>{{ outcomeRevision.cap | number }}</td>
                                }
                                @if (showExemption) {
                                    <td>{{ outcomeRevision.exemption | number }}</td>
                                }
                                <td>{{ outcomeRevision.taxableMarketValue | number }}</td>
                                @if (showTaxableAssessedValue) {
                                    <td>{{ outcomeRevision.taxableAssessedValue ?? 0 | number: '1.0-0' }}</td>
                                }
                                @if (showBaseRate) {
                                    <td>{{ outcomeRevision.baseRate | percent: '1.6-6' }}</td>
                                }
                                @if (showRate) {
                                    <td>{{ outcomeRevision.rate | percent: '1.6-6' }}</td>
                                }
                                <td>{{ outcomeRevision.taxAmount | currency: 'USD' }}</td>
                            </tr>
                        }
                        <tr>
                            <td [attr.colspan]="rightJustifyCellValue">{{
                                parcelCalculation.outcomeRevisionTotalTaxAmount | currency: 'USD'
                            }}</td>
                        </tr>
                        <tr>
                            <td [attr.colspan]="rightJustifyCellValue"></td>
                        </tr>
                        @if (showParcelInfo) {
                            <tr>
                                <td [attr.colspan]="rightJustifyCellValue - 1"
                                    >Savings for Parcel {{ parcelCalculation.parcelName }}:</td
                                >
                                <td>{{ parcelCalculation.parcelTotalSavings | currency: 'USD' }}</td>
                            </tr>
                        }
                    }
                    <tr>
                        <td [attr.colspan]="rightJustifyCellValue - 1">Total Savings:</td>
                        <td [ngClass]="{ 'text-strike': isSavingsOverridden }">{{ totalSavings | currency: 'USD' }}</td>
                    </tr>
                    @if (isSavingsOverridden) {
                        <tr>
                            <td [attr.colspan]="rightJustifyCellValue - 1"></td>
                            <td class="red">{{ overriddenSavingsAmount | currency: 'USD' }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        }
    </div>
</ws-modal-wrapper>
